/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { ContainerModel, Orientation, Alignment, Orientations, Alignments } from '@typescript-kit/view';
import { BaseDirective } from '../../directive/base.directive';
import { ChangedEvent } from '@typescript-kit/core';

@Component({
  selector: 'kit-container,[kitContainer]',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContainerComponent extends BaseDirective<ContainerModel> {
  private orientation: Orientation;
  private alignment: Alignment;

  get hostClass(): string {
    return 'kit-container';
  }

  @Input()
  set kitContainer(model: ContainerModel) {
    this.model = model;
  }

  get kitContainer(): ContainerModel {
    return this.model;
  }

  protected onModelChanged(model: ContainerModel) {
    super.onModelChanged(model);
    this.refreshOrientation();
    this.refreshAlignment();
  }

  protected onModelPropertyChanged(event: ChangedEvent) {
    super.onModelPropertyChanged(event);
    if (event.changes['orientation']) {
      this.refreshOrientation();
    }
    if (event.changes['alignment']) {
      this.refreshAlignment();
    }
  }

  private refreshOrientation() {
    const originalOrientation = this.orientation;
    this.orientation = this.model ? this.model.orientation : undefined;
    if (this.orientation === originalOrientation) {
      return;
    }
    if (originalOrientation) {
      this.removeClass(originalOrientation, 'kit-orientation-');
    }
    if (this.orientation) {
      this.addClass(this.orientation, 'kit-orientation-');
    }
  }

  private refreshAlignment() {
    const originalAlignment = this.alignment;
    this.alignment = this.model ? this.model.alignment : undefined;
    if (this.alignment === originalAlignment) {
      return;
    }
    if (originalAlignment) {
      this.removeClass(originalAlignment, 'kit-alignment-');
    }
    if (this.alignment) {
      this.addClass(this.alignment, 'kit-alignment-');
    }
  }

}
